import { ElementRef, TemplateRef } from "@angular/core";
import { ActionPlanService } from '../../../action-plan/action-plan.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import moment from "moment/moment";
import { SessionService } from '../../../session/session.service';
import { ActivatedRoute } from "@angular/router";
import { SessionSummary } from '../../../../shared/model/session-summary.model';
import { AccountService } from '../../../../core/auth/account.service';
import { JhiEventManager } from '../../../../ng-jhipster/service';
import { RateSessionComponent } from '../../../../shared/rate/rate-session.component';
import { RatingService } from '../../../rating/rating.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../action-plan/action-plan.service";
import * as i2 from "../../../session/session.service";
import * as i3 from "@ng-bootstrap/ng-bootstrap";
import * as i4 from "@angular/router";
import * as i5 from "../../../../core/auth/account.service";
import * as i6 from "../../../../ng-jhipster/service";
import * as i7 from "../../../rating/rating.service";
import * as i8 from "@angular/common";
import * as i9 from "../../../../ng-jhipster/language/jhi-translate.directive";
import * as i10 from "@angular/material/tooltip";
import * as i11 from "@fortawesome/angular-fontawesome";
import * as i12 from "../../chat-ui-new/chat-ui-new.component";
import * as i13 from "../../../action-plan/action-plan/action-plan.component";
import * as i14 from "../coach-user-note/coach-user-note.component";
import * as i15 from "../../session-summary/session-summary.component";
import * as i16 from "@ngx-translate/core";
const _c0 = ["sessionDoesNotExistModal"];
function PreviousSessionTranscriptPopupComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "button", 15);
    i0.ɵɵlistener("click", function PreviousSessionTranscriptPopupComponent_div_3_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.switchToChat(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelementStart(4, "button", 16);
    i0.ɵɵlistener("click", function PreviousSessionTranscriptPopupComponent_div_3_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.switchToActionPlan(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelementStart(6, "button", 17);
    i0.ɵɵlistener("click", function PreviousSessionTranscriptPopupComponent_div_3_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r9); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.switchToNotes(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r0.getChatButtonColor());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r0.getActionPlanButtonColor());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r0.getNotesButtonColor());
} }
function PreviousSessionTranscriptPopupComponent_div_5_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "button", 25);
    i0.ɵɵlistener("click", function PreviousSessionTranscriptPopupComponent_div_5_div_1_div_1_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(3); return ctx_r17.switchToSessionMessages(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelementStart(4, "button", 26);
    i0.ɵɵlistener("click", function PreviousSessionTranscriptPopupComponent_div_5_div_1_div_1_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r18); const ctx_r19 = i0.ɵɵnextContext(3); return ctx_r19.switchToTranscripts(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r16.getSessionMessagesButtonColor());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r16.getTranscriptsButtonColor());
} }
function PreviousSessionTranscriptPopupComponent_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, PreviousSessionTranscriptPopupComponent_div_5_div_1_div_1_Template, 5, 2, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.session);
} }
function PreviousSessionTranscriptPopupComponent_div_5_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "fa-icon", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r22 = ctx.index;
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("color", i_r22 <= ctx_r20.maxHighLightIndex ? "#44A38B" : "white");
} }
function PreviousSessionTranscriptPopupComponent_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelementStart(1, "div", 28);
    i0.ɵɵelement(2, "input", 29);
    i0.ɵɵelementStart(3, "div", 30);
    i0.ɵɵtemplate(4, PreviousSessionTranscriptPopupComponent_div_5_div_2_div_4_Template, 2, 2, "div", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 32);
    i0.ɵɵelementStart(6, "h4", 33);
    i0.ɵɵlistener("click", function PreviousSessionTranscriptPopupComponent_div_5_div_2_Template_h4_click_6_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(2); return ctx_r23.showFeedBack(); });
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r13.stars);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("jhiTranslate", ctx_r13.maxHighLightIndex ? "sessionChat.button.editFeedback" : "sessionChat.button.leaveFeedback")("matTooltip", i0.ɵɵpipeBind1(7, 5, "sessionChat.button.feedbackTooltip"))("matTooltipPosition", "below")("matTooltipClass", "feedback-tool-tip");
} }
function PreviousSessionTranscriptPopupComponent_div_5_chat_ui_new_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "chat-ui-new", 36);
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("session", ctx_r14.session)("viewportHeight", "100%")("displayingPastSession", true)("ignoreNewReceivedMessages", true);
} }
function PreviousSessionTranscriptPopupComponent_div_5_chat_ui_new_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "chat-ui-new", 37);
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("session", ctx_r15.session)("viewportHeight", "100%")("displayingPastSession", true)("ignoreNewReceivedMessages", true);
} }
function PreviousSessionTranscriptPopupComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, PreviousSessionTranscriptPopupComponent_div_5_div_1_Template, 2, 1, "div", 19);
    i0.ɵɵtemplate(2, PreviousSessionTranscriptPopupComponent_div_5_div_2_Template, 8, 7, "div", 20);
    i0.ɵɵelementStart(3, "div", 21);
    i0.ɵɵtemplate(4, PreviousSessionTranscriptPopupComponent_div_5_chat_ui_new_4_Template, 1, 4, "chat-ui-new", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 21);
    i0.ɵɵtemplate(6, PreviousSessionTranscriptPopupComponent_div_5_chat_ui_new_6_Template, 1, 4, "chat-ui-new", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.session && ctx_r1.session.type === "video");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.isUser);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("height", ctx_r1.isUser ? "calc(100% - 200px)" : "calc(100% - 100px)");
    i0.ɵɵproperty("ngClass", ctx_r1.viewMode === "Chat" ? "d-flex flex-column" : "d-none");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.session);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("height", ctx_r1.isUser ? "calc(100% - 200px)" : "calc(100% - 100px)");
    i0.ɵɵproperty("ngClass", ctx_r1.viewMode === "Transcript" ? "d-flex flex-column" : "d-none");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.session);
} }
function PreviousSessionTranscriptPopupComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "action-plan", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("actionPlan", ctx_r2.actionPlan);
} }
function PreviousSessionTranscriptPopupComponent_div_7_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵlistener("click", function PreviousSessionTranscriptPopupComponent_div_7_div_2_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(2); return ctx_r26.goToLink("/#/notes/" + ctx_r26.session.user.id + "/" + ctx_r26.session.coachId); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 45);
    i0.ɵɵelement(3, "use", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(1, 3, "sessionChat.paragraph.expandInfoNotes"))("matTooltipPosition", "below")("matTooltipClass", "expand-tool-tip");
} }
function PreviousSessionTranscriptPopupComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵelementStart(1, "div", 41);
    i0.ɵɵtemplate(2, PreviousSessionTranscriptPopupComponent_div_7_div_2_Template, 4, 5, "div", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "coach-user-note", 43);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r3.isMastermind && !ctx_r3.isSupervisor);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isEmbedded", true)("userId", ctx_r3.session == null ? null : ctx_r3.session.user.id)("coachId", ctx_r3.session == null ? null : ctx_r3.session.coachId);
} }
function PreviousSessionTranscriptPopupComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "button", 47);
    i0.ɵɵlistener("click", function PreviousSessionTranscriptPopupComponent_div_10_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.switchToActionPlanRight(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelementStart(4, "button", 17);
    i0.ɵɵlistener("click", function PreviousSessionTranscriptPopupComponent_div_10_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r29); const ctx_r30 = i0.ɵɵnextContext(); return ctx_r30.switchToNotesRight(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r4.getActionPlanButtonColorRight());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r4.getNotesButtonColorRight());
} }
function PreviousSessionTranscriptPopupComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵelement(1, "action-plan", 39);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("actionPlan", ctx_r5.actionPlan);
} }
function PreviousSessionTranscriptPopupComponent_div_12_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵlistener("click", function PreviousSessionTranscriptPopupComponent_div_12_div_2_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(2); return ctx_r32.goToLink("/#/notes/" + ctx_r32.session.user.id + "/" + ctx_r32.session.coachId); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 50);
    i0.ɵɵelement(3, "use", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(1, 3, "sessionChat.paragraph.expandInfoNotes"))("matTooltipPosition", "below")("matTooltipClass", "expand-tool-tip");
} }
function PreviousSessionTranscriptPopupComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 49);
    i0.ɵɵelementStart(1, "div", 41);
    i0.ɵɵtemplate(2, PreviousSessionTranscriptPopupComponent_div_12_div_2_Template, 4, 5, "div", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "coach-user-note", 43);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r6.isMastermind && !ctx_r6.isSupervisor);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isEmbedded", true)("userId", ctx_r6.session == null ? null : ctx_r6.session.user.id)("coachId", ctx_r6.session == null ? null : ctx_r6.session.coachId);
} }
function PreviousSessionTranscriptPopupComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵelementStart(1, "session-summary", 52);
    i0.ɵɵlistener("ratingOutput", function PreviousSessionTranscriptPopupComponent_div_13_Template_session_summary_ratingOutput_1_listener($event) { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(); return ctx_r34.onRatingOutputChange($event); })("closeSessionSummaryOutput", function PreviousSessionTranscriptPopupComponent_div_13_Template_session_summary_closeSessionSummaryOutput_1_listener($event) { i0.ɵɵrestoreView(_r35); const ctx_r36 = i0.ɵɵnextContext(); return ctx_r36.onCloseSessionSummary($event); })("hideSessionSummaryOutput", function PreviousSessionTranscriptPopupComponent_div_13_Template_session_summary_hideSessionSummaryOutput_1_listener($event) { i0.ɵɵrestoreView(_r35); const ctx_r37 = i0.ɵɵnextContext(); return ctx_r37.onHideSessionSummary($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("showSessionSummary", ctx_r7.showSessionSummary)("sessionId", ctx_r7.session == null ? null : ctx_r7.session.id);
} }
const _c1 = function (a0) { return { "opacity": a0 }; };
export class PreviousSessionTranscriptPopupComponent {
    constructor(actionPlanService, sessionService, modalService, activatedRoute, elementRef, accountService, eventManager, ratingService) {
        this.actionPlanService = actionPlanService;
        this.sessionService = sessionService;
        this.modalService = modalService;
        this.activatedRoute = activatedRoute;
        this.elementRef = elementRef;
        this.accountService = accountService;
        this.eventManager = eventManager;
        this.ratingService = ratingService;
        this.sessionId = this.activatedRoute.snapshot.params["sessionId"];
        this.switchTo = 'chat';
        this.switchToRight = 'action plan';
        this.viewMode = 'Chat';
        this.stars = [1, 2, 3, 4, 5];
        this.sessionSummary = new SessionSummary();
        this.showSessionSummary = false;
        this.hideContent = false;
    }
    set session(value) {
        this._session = value;
        this.loadSession();
    }
    get session() {
        return this._session;
    }
    ngOnInit() {
        this.isUser = this.accountService.isUser();
        this.isCoach = this.accountService.isCoach();
        this.isSupervisor = this.accountService.isSupervisor();
        this.isMastermind = this.accountService.isMastermind();
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#F7F4EB';
        if (this.sessionId && !this.session) {
            this.sessionService.find(this.sessionId).subscribe(res1 => {
                this._session = res1.body;
                this.loadSession();
                this.getRating(this.sessionId);
            }, err => this.onError(err));
        }
        else {
            console.log("Session id not found.");
        }
        this.eventManager.subscribe('maxHighLightIndexUpdated', () => {
            this.getRating(this.sessionId);
        });
    }
    getRating(sessionId) {
        if (this.isCoach) {
            this.sessionService.getSessionSummaryBySessionId(sessionId).subscribe((res2) => {
                console.log(res2);
                this.sessionSummary = res2.body;
                this.maxHighLightIndex = this.sessionSummary.rating - 1;
            }, (errorResponse) => {
                console.log(errorResponse);
            });
        }
        else {
            this.ratingService.findBySessionId(sessionId).subscribe(res3 => {
                console.log(res3);
                this.maxHighLightIndex = res3.body.rating - 1 || null;
            });
        }
    }
    loadSession() {
        var _a;
        this.sessionStartTime = moment((_a = this.session) === null || _a === void 0 ? void 0 : _a.sessionStartTime).format('hh:mm a');
        this.user = this.session.user;
        this.fetchActiveActionPlan();
    }
    onError(err) {
        console.log('error occurred: ' + JSON.stringify(err.status));
        if (err.status === 404) {
            this.modalService.open(this.sessionDoesNotExistModal);
        }
    }
    fetchActiveActionPlan() {
        this.actionPlanService.findBySessionId(this.session.id).subscribe((res) => {
            this.actionPlan = res.body;
            console.log(this.actionPlan);
        }, err => {
            console.log(err.message);
        });
    }
    switchToChat() {
        this.switchTo = 'chat';
    }
    switchToActionPlan() {
        this.switchTo = 'action plan';
    }
    switchToActionPlanRight() {
        this.switchToRight = 'action plan';
    }
    switchToNotes() {
        this.switchTo = 'notes';
    }
    switchToNotesRight() {
        this.switchToRight = 'notes';
    }
    switchToSessionMessages() {
        this.viewMode = 'Chat';
        this.eventManager.broadcast('update-chat-ui-component-size');
    }
    switchToTranscripts() {
        this.viewMode = 'Transcript';
        this.eventManager.broadcast('update-chat-ui-component-size');
    }
    getChatButtonColor() {
        let result;
        if (this.switchTo === 'chat')
            result = 'btn-primary';
        else
            result = 'btn-secondary';
        return result;
    }
    getActionPlanButtonColor() {
        let result;
        if (this.switchTo === 'action plan')
            result = 'btn-primary';
        else
            result = 'btn-secondary';
        return result;
    }
    getActionPlanButtonColorRight() {
        let result;
        if (this.switchToRight === 'action plan')
            result = 'btn-primary';
        else
            result = 'btn-secondary';
        return result;
    }
    getNotesButtonColor() {
        let result;
        if (this.switchTo === 'notes')
            result = 'btn-primary';
        else
            result = 'btn-secondary';
        return result;
    }
    getNotesButtonColorRight() {
        let result;
        if (this.switchToRight === 'notes')
            result = 'btn-primary';
        else
            result = 'btn-secondary';
        return result;
    }
    getSessionMessagesButtonColor() {
        let result;
        if (this.viewMode === 'Chat')
            result = 'btn-primary';
        else
            result = 'btn-secondary';
        return result;
    }
    getTranscriptsButtonColor() {
        let result;
        if (this.viewMode === 'Transcript')
            result = 'btn-primary';
        else
            result = 'btn-secondary';
        return result;
    }
    getCommentLength(field) {
        return !field ? 0 : field.length;
    }
    onCloseSessionSummary(e) {
        this.showSessionSummary = e;
    }
    onHideSessionSummary(e) {
        this.hideContent = e;
    }
    onRatingOutputChange(e) {
        this.maxHighLightIndex = e;
    }
    goToLink(link) {
        window.open(link, '_blank');
    }
    showFeedBack() {
        if (this.isCoach) {
            this.showSessionSummary = true;
        }
        else {
            const modalRef = this.modalService.open(RateSessionComponent, { size: 'lg', backdrop: 'static' });
            modalRef.componentInstance.session = this.session;
            modalRef.componentInstance.displayingPastSession = true;
        }
    }
}
PreviousSessionTranscriptPopupComponent.ɵfac = function PreviousSessionTranscriptPopupComponent_Factory(t) { return new (t || PreviousSessionTranscriptPopupComponent)(i0.ɵɵdirectiveInject(i1.ActionPlanService), i0.ɵɵdirectiveInject(i2.SessionService), i0.ɵɵdirectiveInject(i3.NgbModal), i0.ɵɵdirectiveInject(i4.ActivatedRoute), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i5.AccountService), i0.ɵɵdirectiveInject(i6.JhiEventManager), i0.ɵɵdirectiveInject(i7.RatingService)); };
PreviousSessionTranscriptPopupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PreviousSessionTranscriptPopupComponent, selectors: [["previous-session-transcript-popup"]], viewQuery: function PreviousSessionTranscriptPopupComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sessionDoesNotExistModal = _t.first);
    } }, inputs: { showInModal: "showInModal", session: "session" }, decls: 14, vars: 15, consts: [[1, "olha-theme"], [3, "ngClass", "ngStyle"], [1, "d-flex", "justify-content-center", "d-lg-none", 2, "margin", "30px"], ["class", "col-12 col-sm-12 col-md-12 col-lg-8 card p-0 switch-div", 4, "ngIf"], [1, "d-flex", "justify-content-between", 3, "ngClass"], ["class", "col-12 col-sm-12 col-md-12 col-lg-7 px-0", 4, "ngIf"], ["class", "col-12 col-sm-12 col-md-12 col-lg-7 px-0", "style", "overflow-y: scroll", 4, "ngIf"], ["class", "col-12 col-sm-12 col-md-12 col-lg-8 p-4 flex-grow-1 overflow-hidden", 4, "ngIf"], [1, "d-none", "d-lg-block", "col-lg-4", "px-0", "ml-3"], [1, "d-flex", "justify-content-center", "p-4"], ["class", "col-12 card p-0 switch-div switch-div-border", 4, "ngIf"], ["class", "action-plan-div-pc", 4, "ngIf"], ["class", "action-plan-div-pc-notes pr-4 flex-grow-1", 4, "ngIf"], ["role", "dialog", "aria-labelledby", "myBasicModalLabel", "aria-hidden", "true", "style", "z-index: 1000; position: absolute; left: 0; right: 0; top: 10px; margin: 0 auto;", 4, "ngIf"], [1, "col-12", "col-sm-12", "col-md-12", "col-lg-8", "card", "p-0", "switch-div"], ["type", "button", "jhiTranslate", "sessionChat.button.chat", 1, "btn", "left-button", 3, "ngClass", "click"], ["type", "button", "jhiTranslate", "sessionChat.button.actionPlan", 1, "btn", "middle-button", 3, "ngClass", "click"], ["type", "button", "jhiTranslate", "sessionChat.button.notes", 1, "btn", "right-button", 3, "ngClass", "click"], [1, "col-12", "col-sm-12", "col-md-12", "col-lg-7", "px-0"], ["class", "d-flex justify-content-center p-4", 4, "ngIf"], ["class", "your-session-started-header bg-1 d-flex align-items-center justify-content-center", "style", "border-radius: 10px; ", 4, "ngIf"], [1, "p-1", 2, "position", "absolute", "left", "0", "right", "0", 3, "ngClass"], ["style", "height: 100%", 3, "session", "viewportHeight", "displayingPastSession", "ignoreNewReceivedMessages", 4, "ngIf"], ["displayTranscriptions", "true", "isMessageReactionsEnabled", "false", "style", "height: 100%", 3, "session", "viewportHeight", "displayingPastSession", "ignoreNewReceivedMessages", 4, "ngIf"], [1, "col-12", "card", "p-0", "switch-div", "switch-div-border"], ["type", "button", "jhiTranslate", "sessionChat.button.sessionMessages", 1, "btn", "left-button", 3, "ngClass", "click"], ["type", "button", "jhiTranslate", "sessionChat.button.transcripts", 1, "btn", "right-button", 3, "ngClass", "click"], [1, "your-session-started-header", "bg-1", "d-flex", "align-items-center", "justify-content-center", 2, "border-radius", "10px"], [1, "rating-stars", "d-flex", "align-items-center", "justify-content-center"], ["type", "hidden", "readonly", "readonly", "name", "another-rating-stars-value", "value", "5", 1, "rating-value"], [1, "rating-stars-container"], ["class", "rating-star", 4, "ngFor", "ngForOf"], [1, "d-flex", "align-items-center", "justify-content-center", "ml-1"], [1, "feedback-text", 3, "jhiTranslate", "matTooltip", "matTooltipPosition", "matTooltipClass", "click"], [1, "rating-star"], ["icon", "star"], [2, "height", "100%", 3, "session", "viewportHeight", "displayingPastSession", "ignoreNewReceivedMessages"], ["displayTranscriptions", "true", "isMessageReactionsEnabled", "false", 2, "height", "100%", 3, "session", "viewportHeight", "displayingPastSession", "ignoreNewReceivedMessages"], [1, "col-12", "col-sm-12", "col-md-12", "col-lg-7", "px-0", 2, "overflow-y", "scroll"], ["showAll", "true", 3, "actionPlan"], [1, "col-12", "col-sm-12", "col-md-12", "col-lg-8", "p-4", "flex-grow-1", "overflow-hidden"], [1, "d-flex", "align-items-center", "justify-content-end", "pr-4"], ["class", "expand-div", 3, "matTooltip", "matTooltipPosition", "matTooltipClass", "click", 4, "ngIf"], [3, "isEmbedded", "userId", "coachId"], [1, "expand-div", 3, "matTooltip", "matTooltipPosition", "matTooltipClass", "click"], [1, "expand", 2, "width", "1rem!important", "height", "1rem!important"], [0, "xlink", "href", "../../../../../../../../../../../../content/images/sprite.svg?v=3#expand"], ["type", "button", "jhiTranslate", "sessionChat.button.actionPlan", 1, "btn", "left-button", 3, "ngClass", "click"], [1, "action-plan-div-pc"], [1, "action-plan-div-pc-notes", "pr-4", "flex-grow-1"], [1, "expand", 2, "width", "1.2rem!important", "height", "1.2rem!important"], ["role", "dialog", "aria-labelledby", "myBasicModalLabel", "aria-hidden", "true", 2, "z-index", "1000", "position", "absolute", "left", "0", "right", "0", "top", "10px", "margin", "0 auto"], [3, "showSessionSummary", "sessionId", "ratingOutput", "closeSessionSummaryOutput", "hideSessionSummaryOutput"]], template: function PreviousSessionTranscriptPopupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, PreviousSessionTranscriptPopupComponent_div_3_Template, 7, 3, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, PreviousSessionTranscriptPopupComponent_div_5_Template, 7, 10, "div", 5);
        i0.ɵɵtemplate(6, PreviousSessionTranscriptPopupComponent_div_6_Template, 3, 1, "div", 6);
        i0.ɵɵtemplate(7, PreviousSessionTranscriptPopupComponent_div_7_Template, 4, 4, "div", 7);
        i0.ɵɵelementStart(8, "div", 8);
        i0.ɵɵelementStart(9, "div", 9);
        i0.ɵɵtemplate(10, PreviousSessionTranscriptPopupComponent_div_10_Template, 5, 2, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, PreviousSessionTranscriptPopupComponent_div_11_Template, 2, 1, "div", 11);
        i0.ɵɵtemplate(12, PreviousSessionTranscriptPopupComponent_div_12_Template, 4, 4, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, PreviousSessionTranscriptPopupComponent_div_13_Template, 2, 2, "div", 13);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.showInModal ? "" : "container")("ngStyle", i0.ɵɵpureFunction1(13, _c1, ctx.showSessionSummary && !ctx.hideContent ? 0.3 : 1));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.session);
        i0.ɵɵadvance(1);
        i0.ɵɵstyleProp("margin", ctx.showInModal ? "0" : "0 30px");
        i0.ɵɵproperty("ngClass", ctx.showInModal ? "chat-ui-part-modal" : "chat-ui-part");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.switchTo === "chat");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.switchTo === "action plan");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.switchTo === "notes");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.session && !ctx.isUser);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.switchToRight === "action plan");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.switchToRight === "notes");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showSessionSummary);
    } }, directives: [i8.NgClass, i8.NgStyle, i8.NgIf, i9.JhiTranslateDirective, i8.NgForOf, i10.MatTooltip, i11.FaIconComponent, i12.ChatUiNewComponent, i13.ActionPlanComponent, i14.CoachUserNoteComponent, i15.SessionSummaryComponent], pipes: [i16.TranslatePipe], styles: [".container[_ngcontent-%COMP%]{margin-top:20px;max-width:1500px;overflow-x:hidden;overflow-y:scroll;position:absolute;left:0;right:0;height:calc(100% - 40px)}.switch-div[_ngcontent-%COMP%]{display:grid;grid-auto-columns:minmax(0, 1fr);grid-auto-flow:column}.switch-div-border[_ngcontent-%COMP%]{border:1px solid #44a38b;border-radius:20px}.left-button[_ngcontent-%COMP%]{min-width:100% !important;border-bottom-right-radius:0 !important;border-top-right-radius:0 !important;border:none !important}.middle-button[_ngcontent-%COMP%]{min-width:100% !important;border-radius:0 !important;border:none !important}.right-button[_ngcontent-%COMP%]{min-width:100% !important;border-bottom-left-radius:0 !important;border-top-left-radius:0 !important;border:none !important}.chat-ui-part[_ngcontent-%COMP%]{background-color:#fff !important;border:none !important;border-radius:20px !important;height:calc(100% - 160px);position:relative !important;margin:0 30px}.chat-ui-part-modal[_ngcontent-%COMP%]{background-color:#fff !important;border:none !important;border-radius:20px !important;position:absolute !important;width:100%;height:100%;top:0;left:0;margin:10px}.notes-form[_ngcontent-%COMP%]{padding:20px !important}.form-control[_ngcontent-%COMP%]{height:500px !important;border:1px solid #e1e1e1;outline:0 !important;box-shadow:0 0 0 0 rgba(0,0,0,0) !important}.alert-box-actions[_ngcontent-%COMP%]{text-align:center;margin-top:10px !important}.rounded-button[_ngcontent-%COMP%]{padding-top:3px !important;padding-bottom:3px !important;margin:5px;border-radius:40px;width:100px}.action-plan-div-pc[_ngcontent-%COMP%]{overflow-y:scroll !important;overflow-x:hidden !important;height:calc(100% - 120px) !important}.action-plan-div-pc-notes[_ngcontent-%COMP%]{height:80% !important}.rating-stars[_ngcontent-%COMP%]   .rating-stars-container[_ngcontent-%COMP%]   .rating-star[_ngcontent-%COMP%]{display:inline-block;font-size:26px;cursor:default !important;color:#ebedf5}.your-session-started-header[_ngcontent-%COMP%]{margin:8px 12px 12px 12px !important;border:none !important;border-radius:5px !important}.feedback-text[_ngcontent-%COMP%]{text-decoration:underline !important;color:#44a38b !important;cursor:pointer !important;font-size:14px !important;margin:0 !important}.chat-container-coach[_ngcontent-%COMP%]{height:calc(100% - 100px)}@media(min-width: 768px){.your-session-started-header[_ngcontent-%COMP%]{margin:16px 30px 20px 30px !important;border:none !important;border-radius:10px !important}}@media(min-width: 992px){.container[_ngcontent-%COMP%]{margin-top:60px;height:calc(100% - 60px)}.chat-ui-part[_ngcontent-%COMP%]{height:calc(100% - 70px)}}"] });
